// スライドショー 
const swiper = new Swiper('.js-swiper', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 20,
  preventClicks: false,
  preventClicksPropagation: false,
  autoplay: {
    delay: 6000,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});

const swiperSp = new Swiper('.js-swiper-sp', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  preventClicks: false,
  preventClicksPropagation: false,
  autoplay: {
    delay: 6000,
  },
  pagination: {
    el: '.swiper-pagination',
  }
});